import { message, ThemeConfig } from 'antd'
import PALLETTE from './pallette.module.scss'
const controlHeight = 50

// message.config({
//   duration: 2,
//   maxCount: 3,
// })

export const defaultTheme: ThemeConfig = {
  token: {
    colorPrimary: PALLETTE.primaryColor,
    controlHeight: 40,
    fontSize: 16,
    borderRadius: 8,
  },
  components: {
    Button: {
      controlHeight,
      colorText: PALLETTE.textColor,
    },
    Select: {
      controlHeight,
    },
    DatePicker: {
      controlHeight,
    },
    Input: {
      controlHeight,
    },
    InputNumber: {
      controlHeight,
    },
    Layout: {
      headerBg: PALLETTE.primaryColor,
      headerColor: 'white',
    },
    Menu: {
      darkItemSelectedBg: PALLETTE.secondaryColor,
      subMenuItemSelectedColor: PALLETTE.secondaryColor,
    },
    Table: {
      rowSelectedBg: PALLETTE.secondaryColor,
      rowSelectedHoverBg: PALLETTE.secondaryColorLighten,
    },
  },
}
